"use strict";

var _regeneratorRuntime = require("/Users/moesalih/Documents/GitHub/moesalih/elliss/elliss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/moesalih/Documents/GitHub/moesalih/elliss/elliss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Users/moesalih/Documents/GitHub/moesalih/elliss/elliss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/moesalih/Documents/GitHub/moesalih/elliss/elliss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WalletLinkRelayAbstract = exports.APP_VERSION_KEY = exports.LOCAL_STORAGE_ADDRESSES_KEY = exports.WALLET_USER_NAME_KEY = void 0;

var eth_rpc_errors_1 = require("eth-rpc-errors");

exports.WALLET_USER_NAME_KEY = "walletUsername";
exports.LOCAL_STORAGE_ADDRESSES_KEY = "Addresses";
exports.APP_VERSION_KEY = "AppVersion";

var WalletLinkRelayAbstract = /*#__PURE__*/function () {
  function WalletLinkRelayAbstract() {
    _classCallCheck(this, WalletLinkRelayAbstract);
  }

  _createClass(WalletLinkRelayAbstract, [{
    key: "makeEthereumJSONRPCRequest",
    value: function () {
      var _makeEthereumJSONRPCRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(request, jsonRpcUrl) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (jsonRpcUrl) {
                  _context.next = 2;
                  break;
                }

                throw new Error("Error: No jsonRpcUrl provided");

              case 2:
                return _context.abrupt("return", window.fetch(jsonRpcUrl, {
                  method: "POST",
                  body: JSON.stringify(request),
                  mode: "cors",
                  headers: {
                    "Content-Type": "application/json"
                  }
                }).then(function (res) {
                  return res.json();
                }).then(function (json) {
                  if (!json) {
                    throw eth_rpc_errors_1.ethErrors.rpc.parse({});
                  }

                  var response = json;
                  var error = response.error;

                  if (error) {
                    throw (0, eth_rpc_errors_1.serializeError)(error);
                  }

                  return response;
                }));

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function makeEthereumJSONRPCRequest(_x, _x2) {
        return _makeEthereumJSONRPCRequest.apply(this, arguments);
      }

      return makeEthereumJSONRPCRequest;
    }()
  }]);

  return WalletLinkRelayAbstract;
}();

exports.WalletLinkRelayAbstract = WalletLinkRelayAbstract;